export const NAT_RULE_LABEL_KEYS = {
  INTERNAL: {
    IP: 'internalNatToIp',
    VM_NIC: 'internalNatToVm',
  },
  PUBLIC: { IP: 'publicNatToIp', VM_NIC: 'publicNatToVm' },
};
